import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const IconListItem = ({ fields, params }) => {
  const iconClass =
    params?.variant === 'with-x-icon'
      ? 'fa-solid fa-xmark fa-fw vds-colour-negative'
      : 'fa-solid fa-check fa-fw vds-colour-positive';

  return (
    <li className="vds-icon-listing__item">
      <i className={iconClass} />
      <Text tag="h6" field={fields.title} style={{ marginBottom: 0 }} />
      <Text field={fields.text} />
    </li>
  );
};

export default IconListItem;
